<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="单位名称"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="单位名称" prop="UnitName">
              <el-input
                v-model="data.UnitName"
                placeholder="请填写单位名称"
                clearable
                v-if="!showUnit"
              ></el-input>
              <el-select
                v-model="data.UnitId"
                @change="selectUnit"
                filterable
                clearable
                v-else
              >
                <el-option
                  v-for="(item, index) in units"
                  :key="index"
                  :value="item.UnitId"
                  :label="item.UnitName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12" v-if="data.RecordId==0">
             <div style="padding-left:10px"> <el-button size="mini" type="success" @click="changeUnit">引用平台计量单位</el-button></div>
            </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        UnitName: "",
        OrderId: 0,
        State: 1,
      },
      list: [],
      units: [
        {
          RecordId: 0,
          OrderId: 0,
          UnitName: "",
          State: 0,
        },
      ],
      place: [],
      arr2: [],
      api: require("@/api/goods/unit").default,
      api2: require("@/api/goods/unitplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        UnitName: [{ required: true, message: "单位名称不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      showUnit: false,
    };
  },
  methods: {
    selectUnit(e) {
      var unit = this.units.filter((x) => x.RecordId == e)[0];
      // this.data = unit;
      this.data.UnitName = unit.UnitName;
      this.data.DataSource = 1;
      this.data.RecordId = 0;
    },
    changeUnit() {
      this.showUnit = true;
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(data) {
      this.getOption();
    },
    getOption() {
      this.loading(true);
      this.api2.list({ State: 1 }).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.units = res.Data;
          this.units.forEach((item) => {
            item.UnitId = item.RecordId;
          });
        }
      });
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      data = this.$commonJs.obj.removeNullKey(data); //这个的作用是移除里面的null字段，有些接口参数传null会报错。

      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.arr2 = [];

      this.units = [];
      this.place = [];
      this.showUnit = false;
    },
  },
};
</script>